export enum Event {
  PcwLoadingPageViewed = 'pcw_loading_page.viewed',
  PcwLoadingPageError = 'pcw_loading_page.error',
  PartnerLoadingPageViewed = 'partner_loading_page.viewed',
  PartnerLoadingPageError = 'partner_loading_page.error',
}
